const actionTypeIdentifier = '54387853-67EE-417E-B988-400B71101D0A'; //this is a newid

export const getInvoiceAuditRules = `GET-INVOICE-AUDIT-RULES${actionTypeIdentifier}`;
export const setInvoiceAuditRulesError = `SET-INVOICE-AUDIT-RULES-ERROR-${actionTypeIdentifier}`;
export const setInvoiceAuditRulesColSearchStr = `SET-INVOICE-AUDIT-RULES-COL-SEARCH-STRING-${actionTypeIdentifier}`;
export const setInvoiceAuditRulesPageSize = `SET-INVOICE-AUDIT-RULES-PAGESIZE-${actionTypeIdentifier}`;
export const sortInvoiceAuditRules = `SORT-INVOICE-AUDIT-RULES-${actionTypeIdentifier}`;
export const resetInvoiceAuditRules = `RESET-INVOICE-AUDIT-RULES-${actionTypeIdentifier}`;

export const getInvoiceAuditRulesDetails = `GET-INVOICE-AUDIT-RULES-DETAILS${actionTypeIdentifier}`;
export const resetInvoiceAuditRulesDetails = `RESET-INVOICE-AUDIT-RULES-DETAILS-${actionTypeIdentifier}`;
export const getAuditChartData = `GET-AUDIT-CHART-DATA-${actionTypeIdentifier}`;
export const getExceptionStatus = `GET-EXCEPTION-STATUS-ID-${actionTypeIdentifier}`;
export const setExceptionStatus = `SET-EXCEPTION-STATUS-${actionTypeIdentifier}`;
export const setAdditionalInfo = `SET-ADDITIONAL-INFO-${actionTypeIdentifier}`;
export const saveExceptionData = `SET-EXCEPTION-STATUS-${actionTypeIdentifier}`;